var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolControlPoint = function SvgFiremapSymbolControlPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-15.587-.025c0-1.71 1.34-2.975 3.16-2.975.887 0 1.834.402 2.43 1.04l-1.006 1.19c-.37-.47-.914-.78-1.4-.78-.796 0-1.4.645-1.4 1.508s.604 1.517 1.4 1.517c.453 0 .997-.268 1.4-.679l1.005 1.073c-.637.687-1.6 1.131-2.489 1.131-1.785 0-3.1-1.29-3.1-3.025m6.12 2.95V9.05H15.2c1.516 0 2.388.754 2.388 2.087 0 1.4-.872 2.204-2.388 2.204h-.922v1.584zm2.582-4.534h-.838V12h.838c.52 0 .821-.285.821-.813 0-.511-.302-.796-.821-.796",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolControlPoint;